"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
const tslib_1 = require("tslib");
const ListItemText_1 = tslib_1.__importDefault(require("@material-ui/core/ListItemText"));
const ListItem_1 = tslib_1.__importDefault(require("@material-ui/core/ListItem"));
const react_1 = tslib_1.__importDefault(require("react"));
exports.ListItem = (props) => {
    const { disabled, description, inset, left, onPress, right, selected, style, title } = props;
    return (react_1.default.createElement(ListItem_1.default, { button: !!onPress, disabled: disabled, selected: selected, onClick: onPress, style: style },
        left,
        title || description ? (react_1.default.createElement(ListItemText_1.default, { inset: inset, primary: title, secondary: description })) : null,
        right));
};
